<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 4L2 7L3 7.375V10.8787L1.93933 11.9393L3 13L3.49999 13.5L4 13L5.06065 11.9393L4 10.8787V7.75L10 10L18 7L10 4ZM14 10.5L10 12L6 10.5V14.5C6 14.5 7 16 10 16C13 16 14 14.5 14 14.5V10.5Z"
  />
</svg>
